import Photos from "./gallery";

export default function BlackAndWhiteGallery () {
  return (<>
      <h1 style={{ marginLeft: '3%' }}>Black and White Gallery</h1>
      <Photos type={'blackAndWhite'} />
    </>
  )
} 